<template>
  <section>
    <LoadingSpinner v-if="loading" />

    <div class="mx-2" v-if="!loading">
        
        <div class="card p-2">
            <div class="bd-highlight my-2">
              {{ $t("lang.label.results") }}:
              <small v-if="!total" class="ml-1 text-primary"
                >{{ $t("lang.search.calculating") }}...</small
              >
              <strong v-else>{{ total }}</strong>
            </div>
        </div>
        <div class="col=12 w-100 my-2 card p-2 size-table">
            <div class="mx-0 px-0 table-responsive" v-if="!loading">
                <Table
                    class="mx-2 w-100"
                    :headers="headers"
                    :cols="cols"
                    :data="arrayList"
                    :checkbox="false"
                    :notselect="true"
                    :model="model"
                    :fieldsLoading="fieldsLoading"
                    :key="100"
                >
                </Table>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { targetsService } from "@/_services";
export default {
  name: "OrderSlowingDown",
  components: {
    Table,
    LoadingSpinner,
  },
  data() {
    return {
        loading: false,
        arrayList: [],
        fieldsLoading: true,
        total: 0,
        model: {
            imported: false,
            refreshlist: false,
            selectfirst: false,
            cantPerPage: 25,
            currentPage: 1,
        },
        cols: [
        [
          {
            value: "id",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "stats",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.nonverified"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.verified"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "0",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.unverified"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
             badges: [
              {
                badge_if: "client_status_id",
                badge_value: "2",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.onBoarding.onboarding"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },

              {
                badge_if: "client_status_id",
                badge_value: "9",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.label.validating"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "3",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.active"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "5",
                badge_class: "badge badge-info text-white",
                badge_label: this.$t("lang.appointments.standby"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "8",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.pendingdeleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "7",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.payment.Recovery"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
              {
                badge_if: "client_status_id",
                badge_value: "6",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.deleted"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "duplicate_reason",
          },
        ],
        [
          {
            value_emit: "id",
            value: "target_status_id",
            // class: "text-primary",
            type: "emit",
            emit: "editOrder",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "launch_date_campaign",
          },
        ],
        [
          {
            value: "prospecting_days",
          },
        ],
        [
          {
            value: "id",
            type: "campaignsBadge",
            formatNumber: "true",
            //loading: "false",
          },
        ],
        [
          {
            value: "total_newprospects",
          },
        ],
        [
          {
            value: "total_email_sent",
          },
        ],
        [
          {
            total: "appt_quantity",
            progress: "total_event",
            type: "progressStatus",
          },
        ],   
        [
          {
            value: "conversion_rate",
          },
        ],
         [
          {
            value: "simple_meeting_rate",
          },
        ],
        [
          {
            value: "meeting_rate",
          },
        ],        
        [
          {
            value: "variation_meeting",
          },
        ],      
      ],
      headers: [
        {
          label: this.$t("lang.token.order_id"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.name"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.duplicate_reason"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.status"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
        {
          label: this.$t("lang.column.launch_date"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 12,
        },
        {
          label: this.$t("lang.column.prospecting_days"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 3,
        },
        {
          label: this.$t("lang.label.prospectingemails"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Total sent', //this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Meeting Objetive', //this.$t("lang.label.newleads"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },     
        {
          label: 'Meetings / unique prospects (month)',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
         {
          label: "Meetings/Email sent (month)",
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: 'Meetings / unique prospects (global)',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },       
        {
          label: 'Variation Meeting',
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },     
      ],
    };
  },
  created() {
    this.getOrders();
  },
  methods: {
    getOrders() {
      this.loading = true;
      this.fieldsLoading = true;
      targetsService.getOrderSlowingDown().then(
        (response) => {
          this.arrayList = response.result.data;
          this.total = response.result.total
          this.fieldsLoading = false;
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.fieldsLoading = false;
          this.loading = false;
        }
      );

    },
  },
};
</script>

<style>
.size-table {
    height: 80vh; 
    overflow-x: auto;
}
</style>
